import React, { Component , Fragment } from "react";
import { Parallax } from "react-parallax";
import {Link} from "react-router-dom";
import Slider from "react-slick";
import { slickDot } from "../page-demo/script";

import Header from "../component/header/Header";
import ServiceList from "../elements/service/ServiceList";
import CounterOne from "../elements/counters/CounterOne";
import Testimonial from "../elements/Testimonial";
import Team from "../elements/Team";
import BlogContent from "../elements/blog/BlogContent";
import BrandTwo from "../elements/BrandTwo";
import Footer from "../component/footer/Footer";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";
import { LanguageContext } from '../context/LanguageContext';
import translations from '../translations';

const image1 =
  "/assets/images/bg/paralax/bg-image-3-overlay.jpg";

class CreativeAgency extends Component{
    static contextType = LanguageContext;

    render(){
        const PostList = BlogContent.slice(0 , 5);
        const { language } = this.context;
        const t = translations[language];

        const SlideList = [
            {
                textPosition: 'text-center',
                category: '',
                title: 'mass.Dev ',
                description: t.hero.title,
                buttonText: t.hero.contactButton,
                buttonLink: '/contact'
            }
        ];

        const list = t.portfolio.items.map((item, index) => ({
            image: `image-${(index % 4) + 1}`,
            category: item.category,
            title: item.title,
            id: item.id || `portfolio-${index + 1}`
        }));

        return(
            <Fragment>
                <Helmet pageTitle="Your Web Development Partnere Agency" />
                <Header logo="light" />
                {/* Start Slider Area   */}
                <div className="slider-activation slider-creative-agency">
                    <Parallax bgImage={image1} strength={1000}>
                        {SlideList.map((value , index) => (
                            <div className="slide slide-style-2 slider-paralax d-flex align-items-center justify-content-center" key={index}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className={`inner ${value.textPosition}`}>
                                                {value.category ? <span>{value.category}</span> : ''}
                                                {value.title ? <h1 className="title theme-gradient  text-transform-none ">{value.title}</h1> : ''}
                                                {value.description ? <p className="description">{value.description}</p> : ''}
                                                {value.buttonText ? <div className="slide-btn"><a className="rn-button-style--2 btn-primary-color" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Parallax>
                </div>
                {/* End Slider Area   */}


                {/* Start Service Area  */}
                <div className="service-area creative-service-wrapper ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <span className="subtitle theme-gradient">{t.services.subtitle}</span>
                                    <h2 className="theme-gradient">{t.services.title}</h2>
                                    <p className="d-none d-md-block">{t.services.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row creative-service">
                            <div className="col-lg-12">
                                <ServiceList item="6" column="col-lg-6 col-md-6 col-sm-6 col-12 text-left" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}

                {/* Start Portfolio Area */}
                <div id="portfolio" className="portfolio-area pt--120 pb--140 bg_color--5">
                    <div className="rn-slick-dot">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center mb--30">
                                        <span className="subtitle theme-gradient">{t.portfolio.subtitle}</span>
                                        <h2 className="theme-gradient">{t.portfolio.title}</h2>
                                        <p className="d-none d-md-block">{t.portfolio.description}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="slick-space-gutter--15 slickdot--20">
                                        <Slider {...slickDot}>
                                            {list.map((value , index) => (
                                                <div id={value.id} className="portfolio" key={index}>
                                                    <div className="thumbnail-inner">
                                                        <div className={`thumbnail ${value.image}`}></div>
                                                        <div className={`bg-blr-image ${value.image}`}></div>
                                                    </div>
                                                    <div className="content">
                                                        <div className="inner">
                                                            <p>{value.category}</p>
                                                            <h4><Link to={`/freemium/${value.id}`}>{value.title}</Link></h4>
                                                            <div className="portfolio-button">
                                                                <Link className="rn-btn" to={`/freemium/${value.id}`}>{t.portfolio.readMore}</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Link className="link-overlay" to="/portfolio-details"></Link>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}


                {/* Start CounterUp Area */}
                {/* <div className="rn-counterup-area pt--140 p pb--110 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Team Area  */}
                {/* <div className="rn-team-area ptb--120 bg_color--5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section-title service-style--3 text-left mb--25 mb_sm--0">
                                    <h2 className="title">{t.team.title}</h2>
                                    <p>{t.team.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <Team column="col-lg-4 col-md-6 col-sm-6 col-12" />
                        </div>
                    </div>
                </div> */}
                {/* End Team Area  */}

                {/* Start Slogan Area */}
                <div className="rn-testimonial-area bg_color--1 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <span className="subtitle theme-gradient">{t.slogan.subtitle}</span>
                                   
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-lg-12">
                                <div className="text-center slogan-content">
                                    <h3 className="slogan-text theme-gradient">
                                        {t.slogan.mainSlogan}
                                    </h3>
                                    <p className="slogan-description">
                                        {t.slogan.subSlogan}
                                    </p>
                                    <div className="slide-btn mt--40">
                                        <a className="rn-button-style--2 btn-solid" href="/contact">
                                            <span>{t.slogan.ctaButton}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slogan Area */}
                

                {/* Start Blog Area */}
                <div className="rn-blog-area pt--120 pb--140 bg_color--5 mb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <span className="subtitle theme-gradient">{t.blog.subtitle}</span>
                                    <h2 className="theme-gradient">{t.blog.title}</h2>
                                    <p className="d-none d-md-block">{t.blog.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--55 mt_sm--30 rn-slick-dot slick-space-gutter--15 slickdot--20 row--0">
                            <div className="col-lg-12">
                                <Slider {...slickDot}>
                                    {PostList.map((value , i ) => (
                                        <div className="blog blog-style--1" key={i}>
                                            <div className="thumbnail">
                                                <a href="/blog-details">
                                                    <img src={`/assets/images/blog/blog-${value.images}.jpg`} alt="Blog Images"/>
                                                </a>
                                            </div>
                                            <div className="content">
                                                <p className="blogtype">{value.category}</p>
                                                <h4 className="title"><a href="/blog-details">{value.title}</a></h4>
                                                <div className="blog-btn">
                                                    <a className="rn-btn text-white" href="/blog-details">{t.blog.readMore}</a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Blog Area */}


                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <span className="subtitle theme-gradient">{t.brand.subtitle}</span>
                                    <h2 className="theme-gradient">{t.brand.title}</h2>
                                    <p className="d-none d-md-block">{t.brand.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                {/* Start Footer Style  */}
                <Footer />
                {/* End Footer Style  */}

            </Fragment>
        )
    }
}

export default CreativeAgency;